import React from 'react'
import { NoticeProtected } from '@fs/zion-icon'
import { H3, InfoSheet, useInfoSheet } from '@fs/zion-ui'
import { useQueryParams } from '@fs/zion-router'
import TimeSelector from './TimeSelector'
import CountrySelector from './CountrySelector'
import PermissionsGroup from './PermissionsGroup'
import FixedButton from './FixedButton'
import RainbowText from '../RainbowText'
import { SponsorLevelSelect } from './SponsorLevelSelect'

const paramKey = {
  time: 'time',
  country: 'country',
  permissions: 'permissions',
  sponsorLevel: 'sponsor-level',
}

const QAInfoSheet = () => {
  const { query, removeQuery } = useQueryParams()
  const initiallyOpen = Object.keys(query).some((key) => Object.values(paramKey).includes(key))
  const infoSheet = useInfoSheet({ initiallyOpen })

  const flavor = 'dusk'

  const onClose = () => {
    removeQuery(...Object.values(paramKey))
  }

  const isOpen = infoSheet.isOpen && !infoSheet.transitioning

  return (
    <>
      <FixedButton
        ariaLabel="Open Quality Assurance Tools"
        Icon={NoticeProtected}
        onClick={infoSheet.handleClick}
        flavor={flavor}
      />

      <InfoSheet
        {...infoSheet}
        size="md"
        title={
          <H3 size="H4">
            <RainbowText flavor={flavor}>QA Tools</RainbowText>
          </H3>
        }
        onClose={onClose}
      >
        <TimeSelector paramKey={paramKey.time} isOpen={isOpen} />
        <CountrySelector paramKey={paramKey.country} isOpen={isOpen} />
        <PermissionsGroup paramKey={paramKey.permissions} isOpen={isOpen} />
        <SponsorLevelSelect paramKey={paramKey.sponsorLevel} isOpen={isOpen} />
      </InfoSheet>
    </>
  )
}

export default QAInfoSheet
